import { render } from "./HomeView.vue?vue&type=template&id=49dd9fc8"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giulio/Documents/Sviluppo/chen/categoria/test-pwa-serverless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__